
import React, { Fragment, useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";

import firebaseClient  from '../firebase/FirebaseClient';
import { RECAPTCHA_SITE_KEY } from '../utils/Constants';
import './DataPrivacy.css';

const DataPrivacy = () => {
    // List of your apps from Google Play
    const myApps = [
        "CheckDIY - Images",
        "CAN Chat",
        "Paws Go",
        "For You Messages",
        "Walking Dogs",
        "Emotions AI",
        "Jess Chat Bot",
    ];

    const [formData, setFormData] = useState({
        app: '',
        email: '',
        requestType: '',
        additionalInfo: ''
    });

    const [recaptchaToken, setRecaptchaToken] = useState(null);

    const handleRecaptchaChange = (token) => {
        setRecaptchaToken(token);
    };

    const [isLoading, setIsLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    const [statusType, setStatusType] = useState('');

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!formData.app || !formData.email || !formData.requestType || !recaptchaToken) {
            setStatusMessage('Please fill in all required fields.');
            setStatusType('error');
            return;
        }

        setIsLoading(true);
        setStatusMessage('');

        const { success, message } = await firebaseClient.sendRequest(
            formData.app,
            formData.email, 
            formData.requestType, 
            formData.additionalInfo,
            recaptchaToken
        );
        
        setIsLoading(false);

        if (success) {
            setStatusMessage("Request sent successfully! We will process your data shortly.");
            setStatusType("success");
            setFormData({ app: "", email: "", requestType: "", additionalInfo: "" });
            setRecaptchaToken(null);
        } else {
            setStatusMessage(message || "Submission failed. Please try again.");
            setStatusType("error");
        }
    };

    const resetForm = () => {
        setFormData({ app: "", email: "", requestType: "", additionalInfo: "" });
        setRecaptchaToken(null);
        setStatusMessage("");
        setStatusType("");
    };

    return (
        <Fragment>
            <div className="data-privacy-container">
                <div className="data-privacy-card">
                    <form className="data-privacy-form" onSubmit={handleSubmit}>
                        <h2>Data Privacy Request</h2>
                        <p className="subtitle">Manage your personal information across our applications.</p>

                        <div className="input-group">
                            <label htmlFor="app">Application</label>
                            <select id="app" name="app" value={formData.app} onChange={handleChange} required>
                                <option value="">Select an app</option>
                                {myApps.map((appName) => (
                                    <option key={appName} value={appName}>{appName}</option>
                                ))}
                            </select>
                        </div>

                        <div className="input-group">
                            <label htmlFor="email">Registered Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="your.email@example.com"
                                required
                            />
                        </div>

                        <div className="input-group">
                            <label htmlFor="requestType">Request Type</label>
                            <select id="requestType" name="requestType" value={formData.requestType} onChange={handleChange} required>
                                <option value="">Select request type</option>
                                <option value="deleteAccount">Delete Account</option>
                                <option value="deleteData">Delete Data</option>
                                <option value="deleteBoth">Delete Account & Data</option>
                            </select>
                        </div>

                        <div className="input-group">
                            <label htmlFor="additionalInfo">Additional Details (Optional)</label>
                            <textarea
                                id="additionalInfo"
                                name="additionalInfo"
                                value={formData.additionalInfo}
                                onChange={handleChange}
                                rows="3"
                                placeholder="Any specific details regarding your request..."
                            />
                        </div>

                        {statusMessage && (
                            <div className={`status-box ${statusType}`}>
                                <span>{statusMessage}</span>
                            </div>
                        )}

                        <ReCAPTCHA
                            sitekey={RECAPTCHA_SITE_KEY}
                            onChange={handleRecaptchaChange}
                            className="recaptcha"
                        />

                        <button type="submit" className="submit-btn" disabled={isLoading}>
                            {isLoading ? 'Sending...' : 'Submit Request'}
                        </button>
                    </form>
                </div>
            </div>
        </Fragment>
 
    );
};

export default DataPrivacy;
